export default __webpack_public_path__ + "static/media/latest-news-img31.4c307412.jpg";